import { mapState } from 'vuex';
export default {
  name: 'CoreTenantScopeAccessSelectorRoleWizard',
  props: {
    userId: {
      type: String,
      required: false,
      default: ''
    },
    roles: {
      type: Array,
      required: false,
      default: () => []
    },
    paddingClass: {
      type: String,
      required: false,
      default: () => 'pa-4'
    },
    allowEmptyRoleSet: {
      type: Boolean,
      required: false,
      default: () => false
    },
    dialog: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      chosenRoles: [],
      scopeSelectorFormValid: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    roles() {
      this.chosenRoles = this.roles;
    }
  },
  methods: {
    rolesChosen(roles, scopeId, tenantId) {
      this.$emit('scopeRolesChosen', roles, scopeId, tenantId);
    }
  }
};